var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$slots.default || _vm.hasErrors)?_c('div',{staticClass:"errors-wrapper",class:_vm.ocbClass},[_vm._t("default"),(_vm.hasErrors)?_c('div',{staticClass:"some-errors"},[_c('ul',_vm._l((_vm.messages),function(message,idx){return _c('li',[_vm._v(_vm._s(idx)+": "+_vm._s(message))])}),0)]):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }